module.exports = __webpack_public_path__ + "img/4.2fdae7ca.png";